<template>
  <b-card-code title="Modifier Salle">
    <b-card-text>
      <span>Veuillez modifier les coordonnées de la salle </span>
    </b-card-text>
    <!-- form -->
    <validation-observer
      v-if="salles"
      ref="simpleRules"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Code salle"
              label-for="Code salle"
            >
              <validation-provider
                #default="{ errors }"
                name="Code salle"
                rules="required"
              >
                <b-form-input
                  v-model="salles.room_code"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Code salle"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Type Salle"
              label-for="Type Salle"
            >
              <validation-provider
                #default="{ errors }"
                name="Type Salle"
                rules="required"
              >
                <v-select
                  v-model="salles.type_room"
                  :clearable="false"
                  :options="typeRoom"
                  label="name"
                  placeholder="TypeSalle"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Capacite"
              label-for="Capacite"
            >
              <validation-provider
                #default="{ errors }"
                name="Capacite"
                rules="required"
              >
                <b-form-input
                  v-model="salles.capacity"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Capacite"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <h5>Etat Salle</h5>
              <b-form-checkbox
                v-model="salles.room_condition"
                name="check-button"
                switch
                inline
                @click="salles.room_condition = true"
              >
                Etat Salle
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="editRoom"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormCheckbox,

  },
  data() {
    return {
      salles: {},
      required,
      typeRoom: ['salle info', 'labo info', 'labo technique'],

    }
  },
  created() {
    this.getRooms()
  },
  methods: {
    async getRooms() {
      this.load = 'true'
      const { id } = this.$route.params
      const response = await axios.get(`/api/rooms/detail/${id}`)
      this.salles = response.data
      this.load = 'false'
    },
    async editRoom() {
      this.$refs.simpleRules.validate().then(async success => {
        const { id } = this.$route.params
        if (success) {
          try {
            await axios
              .put(
                `/api/rooms/update/${id}/`,
                {
                  room_code: this.salles.room_code,
                  type_room: this.salles.type_room,
                  capacity: this.salles.capacity,
                  room_condition: this.salles.room_condition,
                },
              )
            this.$router.push('/rooms')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'Sallle Modifié avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
